export * from './use-attachable-text.hook';
